import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import Section from '../../Section';
import SectionList from '../../SectionList';
import { ResidenceCard } from '../../Cards/ResidencesCard';
import { SectionPlaceholder } from '../../Placeholders/SectionPlaceholder';
import ResidenceCardPlaceholder from '../../Placeholders/ResidencesCardPlaceholder';
import { residencesQuery } from '../../../queries';
import { setError } from '../../../actions';

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: errorState => dispatch(setError(errorState))
  };
};

const ResidencesList = ({ setErrorUI }) => {
  const { t } = useTranslation();
  const { loading, data, error } = useQuery(residencesQuery, {
    ssr: false,
    fetchPolicy: 'network-only'
  });
  const placeholder = (
    <SectionPlaceholder more={false}>
      <ResidenceCardPlaceholder />
      <ResidenceCardPlaceholder />
    </SectionPlaceholder>
  );
  const residences = data?.residences || [];
  const residencesList =
    residences &&
    residences.map(item => <ResidenceCard key={item.id} {...item} />);

  useEffect(() => {
    if (error) setErrorUI(true);
  }, [error]);

  if (loading) return placeholder;

  return (
    <Section
      id="residences-page"
      sectionAdditionalClasses="section-page center-block residences-page"
      title={t('sections.residences.title')}
      cypress="residences-page-title"
    >
      <SectionList>{residencesList}</SectionList>
    </Section>
  );
};

ResidencesList.propTypes = {
  setErrorUI: PropTypes.func
};

export default connect(null, mapDispatchToProps)(ResidencesList);
